import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import React from 'react';
import { Button } from '@famly/mf_input_button';
import { Box } from '@famly/mf_layout_box';
import { ModalTestAttributes } from './modal-test-attributes';
import { SplitModalContext } from './split-modal';
/**
 * Switches a split modal between a card and the full screen. Place it in the `SplitModalHeader` next to the
 * `ModalCloseButton`; outside a split modal it renders nothing, and on a phone, where the card already fills the
 * screen, it is hidden.
 */
export const ModalFullScreenButton = () => {
    const context = React.use(SplitModalContext);
    if (!context) {
        return null;
    }
    const { fullScreen, setFullScreen } = context;
    return (_jsx(Box, { display: { base: 'none', mobileLandscape: 'flex' }, alignSelf: "center", children: _jsx(Button, { size: "compact", "data-e2e-id": ModalTestAttributes.fullScreenButtonE2eId, icon: fullScreen ? 'fullscreen_exit' : 'fullscreen', "aria-label": fullScreen
                ? i18next.t($ => $.mf.modalsDialogs_modal.src.translations.json.exitFullScreenButtonAriaLabel)
                : i18next.t($ => $.mf.modalsDialogs_modal.src.translations.json.fullScreenButtonAriaLabel), onClick: () => setFullScreen(!fullScreen), variant: "transparent" }) }));
};
